export const REQUESTS_PAGE_LABELS = {
  openIntakeForm: 'Open intake form',
  pickerTitle: 'Which third-party is this?',
  pickerPlaceholder: 'Search your third-parties, or add a new one',
  missingIntakeEngagement: (name: string) =>
    `This request included the engagement “${name}”. Approving without a name won't create it.`,
  restoreIntakeEngagement: 'Restore',
} as const
